// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* baseModalStyle.css의 \`.MuiDialog-container .MuiPaper-root\` 규칙보다 우선해야 하므로 동일 깊이로 작성 */
.MuiDialog-container .MuiPaper-root.login-required-modal {
  width: 100%;
  max-width: 400px;
  margin: 0;
  padding: 28px 24px 24px 24px;
  border-radius: 20px;
}

@media (max-width: 359px) {
  .MuiDialog-container .MuiPaper-root.login-required-modal {
    padding: 24px 20px 20px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/loginRequiredModalStyle.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* baseModalStyle.css의 `.MuiDialog-container .MuiPaper-root` 규칙보다 우선해야 하므로 동일 깊이로 작성 */\n.MuiDialog-container .MuiPaper-root.login-required-modal {\n  width: 100%;\n  max-width: 400px;\n  margin: 0;\n  padding: 28px 24px 24px 24px;\n  border-radius: 20px;\n}\n\n@media (max-width: 359px) {\n  .MuiDialog-container .MuiPaper-root.login-required-modal {\n    padding: 24px 20px 20px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
